
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { FORM_FIELD } from '../../../ui/formTheme';

const EvaluationRating = ({ name, disabled = false }) => {
    const { register, formState: { errors } } = useFormContext();
    const hasError = !!errors[name];

    return (
        <div className={`flex gap-1 p-1 rounded-lg transition-colors ${hasError ? 'bg-red-50 ring-1 ring-red-200' : ''}`}>
            {[1, 2, 3, 4].map((val) => (
                <label key={val} className="flex items-center justify-center w-10 h-8 cursor-pointer hover:bg-indigo-50 rounded-full transition-colors">
                    <input
                        type="radio"
                        value={val}
                        {...register(name)}
                        disabled={disabled}
                        className={`${FORM_FIELD.radio} cursor-pointer ${hasError ? 'accent-red-600 text-red-600' : ''}`}
                    />
                </label>
            ))}
        </div>
    );
};

export default EvaluationRating;
